<app-filter class="filterBox" [name]="name"(selectedFilter)="handleSelectedFilter($event)" (selectedHeader)="getCoreRangeData($event)"></app-filter>
